import { Label } from "ui/components/label";

export const FormLabel = ({ children, required, className }) => (
  <Label className={className}>
    <div>
      {children}
      {required && <span className="text-red-500 ml-0.5">*</span>}
    </div>
  </Label>
);